import { render, staticRenderFns } from "./Sdate.vue?vue&type=template&id=705488a9&"
import script from "./Sdate.vue?vue&type=script&lang=js&"
export * from "./Sdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports